import React from 'react'
import styled from 'styled-components'
import { PageHero } from '../components'


const AboutPage = () => {
  return( <main>
         <PageHero title='about'></PageHero>
         <Wrapper className='page section section-center'>
           <img src='./images/shoes.jpg' alt='shoe'></img>
           <article>
              <div className='title'>
                <h2>Who We Are</h2>
                <div className='underline'></div>
              </div>
              <p><strong>BenStore</strong> is a reputable online store known for quality, reliability & excellence. What makes us unique is our exceptional customer support service.</p>
              <p>We pledge to be consistent, reliable and to continuously be efficient and effective. Support our cause of transforming online business in this digital age by choosing to buy from us!</p>
            
          </article>
         </Wrapper>
         </main>)
}

const Wrapper = styled.section`
  display: grid;
  gap: 4rem;
 text-align:center;
 
  img {
    width: 100%;
    display: block;
    border-radius: var(--radius);
    height: 20rem;
    object-fit: cover;
  }
  p {
    line-height: 2;
    max-width: 45em;
    margin: 0 auto;
    margin-top: 2rem;
    color: var(--clr-grey-5);
    font-size:1.2rem;
  }
  
  .underline {
    margin:0 auto;
    background-color:rgb(237, 182, 72);
  }
  @media screen and (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
`
export default AboutPage
